import { useGetIdentity, useGetOne } from "ra-core";

import type { Sale } from "../types";

/** Partenaire invité, et si le compte est encore en cours de lecture (pour ne pas montrer d'abord le tableau). */
export const useInvitedState = () => {
  const { identity } = useGetIdentity();
  const { data: sale, isPending } = useGetOne<Sale>(
    "sales",
    { id: identity?.id ?? 0 },
    { enabled: identity?.id != null },
  );
  return {
    invited: !!sale?.partner && sale.partner_offer !== "subscriber",
    isPending: identity?.id == null || isPending,
  };
};

/** Partenaire invité : ni suivi ni recherche de contacts (la base le refuse aussi). */
export const useInvited = () => useInvitedState().invited;

/** Partenaire (invité ou abonné) : ne retire pas une donnée commune à tous, comme le site d'une société. */
export const usePartner = () => {
  const { identity } = useGetIdentity();
  const { data: sale } = useGetOne<Sale>(
    "sales",
    { id: identity?.id ?? 0 },
    { enabled: !!identity?.id },
  );
  return !!sale?.partner && !sale.administrator;
};
